<app-product-comparison-list
  [style]="[]"
  [products]="[uuid]"
  [previewFeatureGroups]="featureGroups"
></app-product-comparison-list>
